import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { PublicSvgIcon } from "~/components/public_svg_icon";

export interface CopyButtonProps {
  value: string;
  label: string;
  dataTestId?: string;
}

export function CopyButton({ value, label, dataTestId }: CopyButtonProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      console.error("Couldn't copy value to clipboard:", err);
    }
  };

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        data-testid={dataTestId}
        onClick={(e) => {
          e.stopPropagation();
          handleCopy();
        }}
      >
        <PublicSvgIcon name="content_copy" size={16} />
      </IconButton>
    </Tooltip>
  );
}
